import { Component, computed, inject, input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from '@tablesready/frontend-badge';
import { AppIcon, AppIconColor, FrontendIconsModule } from '@tablesready/frontend-icons';
import { TableTimeComponent } from '../table-time/table-time.component';
import { cardTypeColorMap, FloorPlanPartyType, getPartyType } from '../get-party-type';
import { PartyNavigationService } from '../party-navigation.service';
import { of, Subscription, switchMap, tap } from 'rxjs';
import { AppTheme, ThemeSwitchService } from '@tablesready/frontend-theme-switch';
import { Party, PartyTypes } from '@shared/party';

@Component({
  selector: 'lib-frontend-party-info-compact',
  standalone: true,
  imports: [CommonModule, BadgeModule, FrontendIconsModule, TableTimeComponent],
  templateUrl: './frontend-party-info-compact.component.html',
  styleUrl: './frontend-party-info-compact.component.scss',
})
export class FrontendPartyInfoCompactComponent implements OnInit, OnDestroy {
  party = input.required<Party>();
  timezone = input<string>();
  editPartyMethod = input.required<(party: Party) => void>();

  partyType = computed(() => {
    const party = this.party();
    return getPartyType(party);
  });

  iconColor = AppIconColor.primary;
  themeService = inject(ThemeSwitchService);
  partyNavigationService = inject(PartyNavigationService);

  private readonly subscriptions = new Subscription();

  ngOnInit(): void {
    this.setColor(this.themeService.getSavedTheme());

    const themeSub = this.themeService.themeChange$
      .pipe(
        switchMap(() => of(this.themeService.getSavedTheme())),
        tap((theme) => {
          this.setColor(theme);
        }),
      ).subscribe();
    this.subscriptions.add(themeSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setColor(theme: AppTheme): void {
    this.iconColor = theme === AppTheme.light ? AppIconColor.primary : AppIconColor.white;
  }

  protected readonly icon = AppIcon;
  protected readonly cardTypeColorMap = cardTypeColorMap;
  protected readonly floorPlanPartyType = FloorPlanPartyType;
  protected readonly partyTypes = PartyTypes;
}
